import axios from "../../utils/axios";
export function cache(data) {
    return axios({
        url: "/cache/restore",
        method: "post",
        data: data
    });
}